namespace $.$$ {

	export class $shm_hitalama_map_widget_float_form_custom extends $.$shm_hitalama_map_widget_float_form_custom {
		
		@ $mol_mem
		custom() {
			return this.widget().form_custom()
		}

		field_names() {
			return this.custom().field_names()
		}

		form_fields(): readonly ( any )[] {
			return this.field_names().map( str => this.Field( str ) )
		}

		field_type( id: string ) {
			const field = this.custom().field_type( id )
			return field
		}

		field_name( name: any ): string {
			return name
		}

		@ $mol_mem_key
		Content_by_type( name: string ): Record< ReturnType< $shm_hitalama_map_widget_float_form_custom['field_type'] >, any > {
			return super.Content_by_type( name )
		}

		Field_content( name: string ) {
			const type = this.field_type( name )
			return this.Content_by_type( name )[ type ]
		}

		@ $mol_mem_key
		field_value( name: any, next?: any ) {
			const type = this.field_type( name )

			if( type == 'file' ) {
				if( next === '' ) {
					this.field_files( name, [] )
					return this.data_value( name, '' )
				}
				const file = this.field_file( name )
				return this.data_value( name, file?.link().toString() )
			}

			return this.data_value( name, next )	
		}

		@ $mol_mem_key
		data_value( name: any, next?: any ) {
			if( this.widget().Data_method()?.val() ) {
				const object = this.widget().data() ?? {}
				if( next === undefined ) {
					if( object[ name ] !== undefined ) return object[ name ] ?? ''

					const legacy = this.custom().object_current_value( name )
					if( legacy !== undefined && legacy !== '' ) {
						this.widget().data({ ...object, [ name ]: legacy })
						return legacy
					}

					return ''
				}

				this.widget().data({ ...object, [ name ]: next })
				return next
			}

			return this.custom().object_current_value( name, next )
		}

		@ $mol_action
		clear() {
			this.field_names().forEach( name => {
				this.field_value( name, '' )
			} )
		}

		@ $mol_mem_key
		field_file( n: string ) {
			const file_native = this.field_files( n )[0]
			if( !file_native ) return null

			const file = this.map().Files(null)?.make( null )
			file?.write( file_native )

			return file!
		}

		submit() {
			const obj = Object.fromEntries( this.field_names().map( n => {

				const type = this.field_type( n )

				if( type == 'date' ) {
					const val = this.field_value( n )
					const moment = new $mol_time_moment( val )
					return [ n, val ? moment.toString('DD.MM.YYYY') : '' ]
				}

				return [ n, this.field_value( n ) ]

			} ) )

			this.custom().obj_add( obj )

			this.clear()
		}

		buttons() {
			return this.buttons_visible() ? super.buttons() : []
		}

		buttons_visible( next?: boolean ): boolean {
			if( next === undefined ) return !this.custom().hide_buttons()
				
			return !this.custom().hide_buttons( !next )
		}
		
	}

}
